// Version : 0.0.1
// Author : SABARI

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*********  CREATE DUPLICATE CENTER GROUP START *********/
export const createDuplicateCenterGroupDetail = (fetchData: any) => {
	const data = {
		AddDuplicateCenterToken: fetchData,
	};
	const url = `${API_URL}createDuplicateCenterGroup`;
	return makeApiCall(url, data);
};
/********* CREATE DUPLICATE CENTER GROUP END  **************/

/********* MEMBER BRANCH TO CENTER TRANSFER START *********/
export const memberBranchToCenterTransfer = (fetchData: any) => {
	const data = {
		AddTransferBranchCenterToken: fetchData,
	};
	const url = `${API_URL}memberBranchCenterTransfer`;
	return makeApiCall(url, data);
};
/********* MEMBER BRANCH TO CENTER TRANSFER END  **************/

/********* TRANSFER MEMBER LIST START *********/
export const transferMemberList = (fetchData: any) => {
	const data = {
		GetMemberListDataToken: fetchData,
	};
	const url = `${API_URL}transferMemberList`;
	return makeApiCall(url, data);
};
/********* TRANSFER MEMBER LIST END *********/

/** ***************** GET ALL CENTER LIST START *********************** */
export const transferCenterFetch = (fetchCenterData: any) => {
	const data = {
		GetAllCenterListToken: fetchCenterData,
	};
	const url = `${API_URL}fetchAllCenterList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL CENTER LIST END *********************** */
